import { parseNumericInput } from './numberInput';

/** Epsilon for comparing integer lot totals against received quantity. */
const QUANTITY_MATCH_EPSILON = 0.001;

/**
 * Returns true when an order item's total batch/lot quantity does not match
 * its received (orderItemQuantity) quantity.
 *
 * Skips items marked "Did not arrive". Prefers `lotQuantityMatch` metadata
 * from `calculateOrderLotQuantities` when present; otherwise computes from
 * `orderItemQuantity` and `lotItems`.
 *
 * @param {Object|null|undefined} item - Order line item from OrderModal state.
 * @returns {boolean}
 */
export function hasItemQuantityMismatch(item) {
  if (!item || item.status === 'Did not arrive') {
    return false;
  }

  if (item.lotQuantityMatch) {
    return !item.lotQuantityMatch.isMatching;
  }

  const orderQuantity =
    parseNumericInput(item.orderItemQuantity, { integerOnly: true }) || 0;
  const lotItems = item.lotItems || [];
  const totalLotQuantity = lotItems.reduce((sum, lot) => {
    const quantity =
      parseNumericInput(lot?.lotItemQuantity || lot?.lot_item_quantity, {
        integerOnly: true,
      }) || 0;
    return sum + quantity;
  }, 0);

  return Math.abs(totalLotQuantity - orderQuantity) >= QUANTITY_MATCH_EPSILON;
}

/**
 * Returns true when any order item has a batch/received quantity mismatch.
 *
 * @param {Object[]|null|undefined} items - Order line items from OrderModal state.
 * @returns {boolean}
 */
export function hasAnyItemQuantityMismatch(items) {
  if (!items || items.length === 0) {
    return false;
  }

  return items.some(hasItemQuantityMismatch);
}
